"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapLine = void 0;
var THREE = require("../../../externals/three");
var SnapLine = /** @class */ (function () {
    function SnapLine(definition) {
        this._line = new THREE.Line3(definition.positionStart, definition.positionEnd);
        this._id = definition.id;
        this._snapRadius = definition.snapRadius;
        this._rotationMatrix = new THREE.Matrix4().makeBasis(definition.orientation.direction.clone().cross(definition.orientation.axis), definition.orientation.direction, definition.orientation.axis);
        this._rotatedStandardDirection = new THREE.Vector3(0, 1, 0).applyMatrix4(this._rotationMatrix);
        this._anchorElements = definition.anchorElements;
    }
    SnapLine.prototype.snap = function (position) {
        var p = new THREE.Vector3();
        p = this._line.closestPointToPoint(position, true, p);
        var distance = p.distanceTo(position);
        var dir = position.clone().sub(p).normalize();
        return {
            snapElement: this,
            distance: distance,
            position: p.clone(),
            dot: dir.dot(this._rotatedStandardDirection),
            snap: distance < this._snapRadius
        };
    };
    Object.defineProperty(SnapLine.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapLine.prototype, "rotationMatrix", {
        get: function () {
            return this._rotationMatrix;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapLine.prototype, "anchorIds", {
        get: function () {
            return this._anchorElements;
        },
        enumerable: false,
        configurable: true
    });
    return SnapLine;
}());
exports.SnapLine = SnapLine;
